/* Centralized admin auth-token storage.
 *
 * Why both cookie + Bearer token? Some browsers/configs (3rd-party cookie blocking,
 * SameSite=None edge cases on production deploys) drop the auth cookie silently.
 * Storing the token in sessionStorage and sending it as a Bearer header makes
 * the admin session work regardless of cookie behaviour.
 *
 * Only used inside the /admin section — public visitors never touch this.
 */
import axios from "axios";

const KEY = "swipetronics_admin_token";

export function getToken() {
  if (typeof window === "undefined") return null;
  try { return window.sessionStorage.getItem(KEY); } catch { return null; }
}

export function setToken(token) {
  if (typeof window === "undefined") return;
  try {
    if (token) {
      window.sessionStorage.setItem(KEY, token);
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    } else {
      window.sessionStorage.removeItem(KEY);
      delete axios.defaults.headers.common["Authorization"];
    }
  } catch (err) { console.warn("[auth-token] storage failed:", err); }
}

/* Restore the Authorization header at app boot if a token exists. */
export function bootstrapToken() {
  const t = getToken();
  if (t) axios.defaults.headers.common["Authorization"] = `Bearer ${t}`;
}
